/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import { RayconCableGraphic, RayconEarbudsGraphic } from '../images';

declare let onetext : OneText;

const { clsx } = onetext.jsx;

export const BrandBackground = () : JSX.Element => (
    <div className={ 'absolute inset-0' }>
        <img
            src={ RayconEarbudsGraphic }
            className={
                clsx(
                    'absolute',
                    'max-w-full',
                    'flex-shrink-0',
                    'left-[-30px]',
                    'w-[140px] md:w-[26%]',
                    'top-[10px] md:top-[50px]',
                    'rotate-[-20deg]',
                    'animation-delay-[0.3s]',
                    'animation-duration-[0.9s]',
                    'fade-in-right-raycon-earbuds',
                    'animation-fill-mode-both'
                )
            } />
        <img
            src={ RayconCableGraphic }
            className={
                clsx(
                    'absolute',
                    'max-w-full',
                    'flex-shrink-0',
                    'w-[160px] md:w-[26%]',
                    'right-[-10px]',
                    'bottom-[-10px]',
                    'rotate-90',
                    'animation-delay-[0.6s]',
                    'animation-duration-[0.9s]',
                    'fade-in-left-raycon-cable',
                    'animation-fill-mode-both'
                )
            } />
    </div>
);
